<template>
  <div class="footer">
    <div class="footer-top">
      <div class="footer-top-main">
        <div class="footer-top-left clearfix">
          <div class="left"><i class="icon-ccui-sharing-o"/>资源共享</div>
          <div class="left"><i class="icon-ccui-excellent-o"/>优质服务</div>
          <div class="left"><i class="icon-ccui-star-o"/>合法合规</div>
          <div class="left"><i class="icon-ccui-rmb-o"/>降本增效</div>
        </div>
        <div class="footer-top-right"><i class="icon-ccui-promote-o"/>管理提升</div>
      </div>
    </div>
    <!--      相关-->
    <div class="footer-mid">
      <div class="footer-mid-main">
        <div class="about clearfix">
          <dl class="left">
            <dt><a href="#">关于我们</a></dt>
            <dd><a href="#">平台简介</a></dd>
            <dd><a href="#">联系我们</a></dd>
            <dd><a href="#">相关政策与规范</a></dd>
          </dl>
          <dl class="left">
            <dt><a href="#">采购方</a></dt>
            <dd><a href="#">操作指引</a></dd>
            <dd><a href="#">视频教程</a></dd>
          </dl>
          <dl class="left">
            <dt><a href="#">供应商</a></dt>
            <dd><a href="#">操作指引</a></dd>
            <dd><a href="#">视频教程</a></dd>
            <dd><a href="#">入网须知</a></dd>
          </dl>
          <dl class="left">
            <dt><a href="#">常见问题</a></dt>
            <dd><a href="#">采购方常见问题</a></dd>
            <dd><a href="#">供应商常见问题</a></dd>
          </dl>
          <dl class="left">
            <dt><a href="#">服务中心</a></dt>
            <dd><a href="#">在线咨询</a></dd>
            <dd><a href="#">售后服务</a></dd>
            <dd><a href="#">意见反馈</a></dd>
            <dd><a href="#">文件模版下载</a></dd>
          </dl>
          <dl class="left">
            <dt><a href="#">供应链金融中心</a></dt>
            <dd><a href="#">操作指引</a></dd>
            <dd><a href="#">常见问题</a></dd>
          </dl>
        </div>
        <div class="code">
          <img src="../../../../assets/images/code.jpg" alt="">
          <p>官方微信</p>
        </div>
      </div>
    </div>
    <!--  版权-->
    <div class="footer-bottom">
      <div class="foo clearfix">
        <p class="left">Copyright©2018中国交建All rights reserved.</p>
        <span class="left">|</span>
        <p class="left">最终解释权：京ICP备 18007572号-1 中国交建</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
  @import "~@/styles/variables";
  .footer {
    width: 100%;
    min-width: 1366px;
    height: 322px;
    background-color: $--color-footer-bg;
  }

  .footer-top {
    width: 100%;
    min-width: 1366px;
    max-width: 1680px;

    margin: 0 auto;
    padding: 0 50px;

    .footer-top-main {
      /deep/ i {
        margin-left: 0px;
        font-weight: 500
      }

      /*display: flex;*/
      /*justify-content: space-between;*/
      position: relative;
      width: 100%;
      height: 80px;
      line-height: 80px;
      border-bottom: 1px solid $--color-table-zebra;
      padding-right: 142px;

      .footer-top-left {
        width: 100%;
        min-width: 1138px;
        height: 100%;
        /*background-color: yellow;*/

        div {
          width: 25%;
        }
      }

      .footer-top-right {
        position: absolute;
        top: 0;
        right: 0;
        width: 142px;
        height: 100%;
        /*background-color: red;*/
      }

      div {
        height: 42px;
        width: 142px;
        font-size: 20px;
        font-weight: 600;
        color: $--color-culture;

        i {
          display: inline-block;
          font-size: 42px;
          color: $--color-primary;
          margin-right: 20px;
          vertical-align: middle;
          margin-top: -4px;
        }
      }
    }
  }

  .footer-mid {
    width: 100%;
    height: 183px;
    margin: 0 auto;
    min-width: 1366px;
    max-width: 1680px;
    padding: 0 50px;

    dl, dt, dd {
      margin: 0;
      padding: 0;
    }

    .footer-mid-main {
      position: relative;
      /*width: 100%;*/
      height: 100%;
      border-bottom: 1px solid $--breadcrumb-separator-color;

      .about {
        height: 100%;
        padding-right: 100px;

        dl {
          width: 16.6%;
        }

        dl:first-child {
          margin-left: 0px;
        }

        dt {
          height: 20px;
          font-size: 14px;
          font-weight: 600;
          color: $--color-assist-topbar-font;
          line-height: 20px;
          margin: 30px 0px 15px 0px;
        }

        dd {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          color: $--color-assist-topbar-font;
          line-height: 17px;
          margin-bottom: 10px;
        }
      }

      .code {
        position: absolute;
        top: 30px;
        right: 0px;
        width: 100px;
        height: 100px;
        text-align: center;

        p {
          color: $--color-assist-topbar-font;
          font-size: 12px;
          font-weight: 500;
          color: $--color-assist-topbar-font;
          margin-top: 10px;

        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .footer-bottom {
    width: 100%;
    margin: 0 auto;

    .foo {
      width: 524px;
      height: 17px;
      margin: 20px auto;
      line-height: 17px;

      p, span {
        margin: 0px;
        font-size: 12px;
        font-weight: 500;
        color: $--color-assist-topbar-font;
      }

      span {
        margin: 0 9px;
      }
    }
  }

  /*浮动*/
  .left {
    float: left;
  }

  .right {
    float: right;
  }

  /*清除浮动*/
  .clearfix:after {
    display: block;
    clear: both;
    content: "";
    visibility: hidden;
    height: 0
  }

  .clearfix {
    zoom: 1
  }
</style>
